import React from "react";

import { useAppStore } from "@store/appStateStore";
import { updateDirection, fetchDirections } from "@services/directionApi";

import AgGridTable from "@components/shared/AgGridTable";
import { ActionCellRenderer } from "@components/shared/actionColumn";

import { getColumnDefs } from "./columnDefs";

const DirectionsTable: React.FC = () => {
  const { directions, setDirections } = useAppStore();

  const handleCellValueChanged = async (params: any) => {
    const { data, colDef, newValue, oldValue } = params;
    if (newValue === oldValue) return;

    const field = colDef.field;
    const updates: any = {};
    updates[field] = newValue;

    try {
      await updateDirection(data.id, updates);

      const updatedDirections = await fetchDirections();
      setDirections(updatedDirections);
    } catch (error) {
      console.error("Ошибка:", error);
      alert("Ошибка обновления направления");
    }
  };

  const handleDeleteSuccess = async () => {
    try {
      const directions = await fetchDirections();
      setDirections(directions);
    } catch (error) {
      console.error("Ошибка загрузки направлений после удаления:", error);
      alert("Ошибка обновления списка направлений");
    }
  };

  const columnDefs = getColumnDefs(handleCellValueChanged, handleDeleteSuccess);

  return (
    <AgGridTable
      title="Направления"
      rowData={directions}
      columnDefs={columnDefs}
      components={{ ActionCellRenderer: ActionCellRenderer }}
    />
  );
};

export default DirectionsTable;
